module.exports = __webpack_public_path__ + "img/86.7ee4081a.png";